import OutreachSection from 'components/Enterprise/OutreachSection';
import React from 'react';
import { ContentWithImage } from 'utils/types';

export interface OutreachContainerProps {
  content: {
    title: string;
    headline: string;
    subHeadline: string;
    listOfContentWithImages: ContentWithImage[];
  };
}
// TODO replace this with a real component or assemblage of components - this is placeholder

export const OutreachContainer: React.FC<OutreachContainerProps> = ({
  content,
}) => {
  if (!content) {
    return null;
  }

  const { title, headline, subHeadline, listOfContentWithImages } = content;

  return (
    <OutreachSection
      title={title}
      headline={headline}
      subheadline={subHeadline}
      listOfContent={listOfContentWithImages}
    />
  );
};

export default OutreachContainer;
